import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const publicUrl = process.env.PUBLIC_URL || '';
    const response = await fetch(`${publicUrl}/config.json`);
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error('Failed to load config.json. Using default .env API URL', error);
  }
}

loadConfig();

export interface CreateDataSourceInput {
  id: string;
  dataSourceName: string;
  assetType: string;
  integrationMethod: string;
  updateFrequency: string;
  clientId: string;
  description?: string;
  filePath?: string;
  fileFormat?: string;
  apiEndpoint?: string;
  apiMethod?: string;
  apiAuthentication?: string;
  dbConnectionString?: string;
  dbUsername?: string;
  dbPassword?: string;
  ldapServer?: string;
  ldapPort?: string;
  ldapBaseDN?: string;
  ftpServer?: string;
  ftpPort?: string;
}

export interface UpdateDataSourceInput extends CreateDataSourceInput {
  id: string;
}

export interface DataSourceListItem {
  id: string;
  dataSourceName: string;
  assetType: string;
  integrationMethod: string;
  updateFrequency: string;
  clientId: string;
  description?: string;
  status?: string;
  lastRun?: string;
  assetsCount?: number;
  createdAt?: string;
}

export const createDataSourceApi = async (data: CreateDataSourceInput) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/data-sources`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Failed to create data source');
    }
    return result;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to create data source');
  }
};

export const updateDataSourceApi = async (data: UpdateDataSourceInput) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/data-sources/${data.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Failed to update data source');
    }
    return result;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to update data source');
  }
};

export const deleteDataSourceApi = async (id: string) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/data-sources/${id}`, {
      method: 'DELETE',
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Failed to delete data source');
    }
    return result;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to delete data source');
  }
};

export const fetchDataApi = async (endpoint: string) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${endpoint}`, {
      method: 'GET',
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Failed to fetch data');
    }
    return result;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to fetch data');
  }
};

